import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import swal from 'sweetalert2';
import WebService from "../../../services/webservice";

const EditAppMenu = ({ show, onHide, onSuccess, menuToEdit }) => {

    const healthIcons = [
        "fa-solid fa-heartbeat", "fa-solid fa-hospital", "fa-solid fa-user-md", "fa-solid fa-stethoscope",
        "fa-solid fa-pills", "fa-solid fa-prescription-bottle-alt", "fa-solid fa-ambulance", "fa-solid fa-plus-square",
        "fa-solid fa-h-square", "fa-solid fa-briefcase-medical", "fa-solid fa-notes-medical", "fa-solid fa-capsules",
        "fa-solid fa-syringe", "fa-solid fa-vial", "fa-solid fa-vials", "fa-solid fa-pump-medical",
        "fa-solid fa-laptop-medical", "fa-solid fa-book-medical", "fa-solid fa-file-medical", "fa-solid fa-file-medical-alt",
        "fa-solid fa-clinic-medical", "fa-solid fa-comment-medical", "fa-solid fa-disease", "fa-solid fa-dna",
        "fa-solid fa-crutch", "fa-solid fa-x-ray", "fa-solid fa-virus", "fa-solid fa-viruses",
        "fa-solid fa-virus-slash", "fa-solid fa-tooth", "fa-solid fa-teeth", "fa-solid fa-teeth-open",
        "fa-solid fa-smoking", "fa-solid fa-smoking-ban", "fa-solid fa-skull-crossbones", "fa-solid fa-prescription",
        "fa-solid fa-lungs", "fa-solid fa-lungs-virus", "fa-solid fa-id-card-clip", "fa-solid fa-hand-holding-medical",
        "fa-solid fa-head-side-mask", "fa-solid fa-head-side-virus", "fa-solid fa-eye", "fa-solid fa-eye-dropper",
        "fa-solid fa-bacteria", "fa-solid fa-bacterium", "fa-solid fa-band-aid", "fa-solid fa-bone",
        "fa-solid fa-brain", "fa-solid fa-calendar-plus", "fa-solid fa-chart-line", "fa-solid fa-clipboard-list",
        "fa-solid fa-robot", "fa-solid fa-bell", "fa-solid fa-question-circle", "fa-solid fa-tachometer-alt",
        "fa-solid fa-user", "fa-solid fa-users", "fa-solid fa-chart-pie", "fa-solid fa-list",
        "fa-solid fa-cogs", "fa-solid fa-cog", "fa-solid fa-wrench", "fa-solid fa-sync",
        "fa-solid fa-sign-out-alt", "fa-solid fa-shield-alt", "fa-solid fa-lock", "fa-solid fa-unlock",
        "fa-solid fa-key", "fa-solid fa-id-badge", "fa-solid fa-home", "fa-solid fa-globe",
        "fa-solid fa-folder", "fa-solid fa-folder-open", "fa-solid fa-file", "fa-solid fa-file-alt",
        "fa-solid fa-envelope", "fa-solid fa-envelope-open", "fa-solid fa-edit", "fa-solid fa-trash",
        "fa-solid fa-trash-alt", "fa-solid fa-search", "fa-solid fa-plus", "fa-solid fa-minus",
        "fa-solid fa-check", "fa-solid fa-times", "fa-solid fa-arrow-up", "fa-solid fa-arrow-down",
        "fa-solid fa-arrow-left", "fa-solid fa-arrow-right", "fa-solid fa-caret-down", "fa-solid fa-caret-up",
        "fa-solid fa-caret-left", "fa-solid fa-caret-right", "fa-solid fa-angle-down", "fa-solid fa-angle-up",
        "fa-solid fa-angle-left", "fa-solid fa-angle-right", "fa-solid fa-chevron-down", "fa-solid fa-droplet",
        "fa-solid fa-apple-whole", "fa-solid fa-pepper-hot", "fa-solid fa-bread-slice", "fa-solid fa-microscope",
        "fa-solid fa-kit-medical", "fa-solid fa-syringe", "fa-solid fa-heart-pulse", "fa-solid fa-arrow-up-from-bracket",
        "fa-solid fa-music", "fa-solid fa-list-check", "fa-solid fa-list", "fa-solid fa-triangle-exclamation",
        "fa-solid fa-users-gear", "fa-solid fa-cogs", "fa-solid fa-rocket", "fa fa-user", "fa fa-microscope",
        "fa-solid fa-chart-column", "fa-solid fa-female", "fa-solid fa-sliders"
    ];

    const iconOptions = healthIcons.map(icon => ({
        value: icon,
        label: icon
    }));

    const formatOptionLabel = ({ value, label }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <i className={value} style={{ fontSize: '18px', marginRight: '10px', width: '25px', textAlign: 'center' }} />
            <span>{label}</span>
        </div>
    );

    const [uniqueParentMenus, setUniqueParentMenus] = useState([]);
    const [availableActions, setAvailableActions] = useState(['View']);
    const [newActionInput, setNewActionInput] = useState('');

    const [formData, setFormData] = useState({
        id: '',
        menuName: '',
        menuPosition: '',
        menuKey: '',
        menuIcon: '',
        urlPath: '',
        menuType: 'Parent Menu',
        parentMenu: '',
        allowedActions: []
    });

    useEffect(() => {
        if (show) {
            fetchUniqueParentMenus();
            if (menuToEdit) {
                populateForm(menuToEdit);
            }
        }
    }, [show, menuToEdit]);

    const populateForm = (menu) => {
        setFormData({
            id: menu._id,
            menuName: menu.menuName,
            menuPosition: menu.menuPosition,
            menuKey: menu.menuKey,
            menuIcon: menu.menuIcon || '',
            urlPath: menu.urlPath || '',
            menuType: menu.menuType || 'Parent Menu',
            parentMenu: menu.parentMenu || '',
            allowedActions: menu.allowedActions || []
        });
        
        const defaultActions = ['View'];
        if (menu.availableActions && menu.availableActions.length > 0) {
            setAvailableActions(menu.availableActions);
        } else {
            const existingCustom = (menu.allowedActions || []).filter(a => !defaultActions.includes(a));
            setAvailableActions([...defaultActions, ...existingCustom]);
        }
        setNewActionInput('');
    };



    const fetchUniqueParentMenus = async () => {
        try {
            const response = await axios.post(`${WebService}api/app-menus`);
            if (response.data.success) {
                const parents = [...new Set(response.data.data.filter(m => m.menuType === 'Parent Menu').map(m => m.menuName))];
                setUniqueParentMenus(parents);
            }
        } catch (error) {
            console.error('Error fetching parent menus:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleIconChange = (selectedOption) => {
        setFormData({ ...formData, menuIcon: selectedOption ? selectedOption.value : '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = { ...formData, availableActions };
            const response = await axios.post(`${WebService}api/update-app-menu`, payload);
            if (response.data.success) {
                swal.fire('Success', response.data.message, 'success');
                if (onSuccess) onSuccess();
                onHide();
            } else {
                swal.fire('Error', response.data.message, 'error');
            }
        } catch (error) {
            console.error('Error saving app menu:', error);
            swal.fire('Error', 'Something went wrong while saving.', 'error');
        }
    };

    const reactSelectStyles = {
        control: (base, state) => ({
            ...base,
            padding: '0px 8px',
            borderRadius: '6px',
            borderColor: state.isFocused ? '#3b82f6' : '#e2e8f0',
            backgroundColor: state.isFocused ? '#ffffff' : '#f8fafc',
            boxShadow: state.isFocused ? '0 0 0 4px rgba(59, 130, 246, 0.1)' : 'none',
            '&:hover': { borderColor: state.isFocused ? '#3b82f6' : '#cbd5e1' },
            minHeight: '36px',
            fontSize: '0.85rem',
            transition: 'all 0.2s'
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
            borderRadius: '10px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            border: '1px solid #e2e8f0',
            overflow: 'hidden'
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#eff6ff' : state.isFocused ? '#f8fafc' : '#ffffff',
            color: state.isSelected ? '#1d4ed8' : '#1e293b',
            cursor: 'pointer',
            '&:active': { backgroundColor: '#eff6ff' }
        })
    };

    if (!show) return null;

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050 }}>
            <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', width: '90%', maxWidth: '800px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 10px 25px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
                <div style={{ padding: '24px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#ffffff', flexShrink: 0 }}>
                    <h2 style={{ margin: 0, fontWeight: '700', color: '#1e293b', fontSize: '1.35rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ background: '#eff6ff', padding: '8px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <i className="fa-solid fa-pen-to-square" style={{ color: '#3b82f6', fontSize: '1rem' }}></i>
                        </div>
                        Edit Menu
                    </h2>
                    <button type="button" onClick={onHide} style={{ background: 'transparent', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#64748b', padding: '0' }}>&times;</button>
                </div>
                <Form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    <div style={{ padding: '0 32px 10px 32px', overflowY: 'auto', flexGrow: 1 }}>
                    <Row className="gx-4">
                        <Col md={6}>
                            <Form.Group className="mb-4">
                                <Form.Label style={{ color: '#64748b', fontWeight: '600', fontSize: '0.85rem', marginBottom: '8px', textTransform: 'capitalize', letterSpacing: '0.2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <i className="fa-solid fa-table-columns" style={{ color: '#64748b', fontSize: '0.9rem' }}></i> Menu Name <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g. Dashboard"
                                    name="menuName"
                                    value={formData.menuName}
                                    onChange={handleInputChange}
                                    required
                                    style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', boxShadow: 'none', transition: 'all 0.2s', fontSize: '0.85rem', backgroundColor: '#ffffff' }}
                                    onFocus={(e) => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 4px rgba(59, 130, 246, 0.1)'; }}
                                    onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-4">
                                <Form.Label style={{ color: '#64748b', fontWeight: '600', fontSize: '0.85rem', marginBottom: '8px', textTransform: 'capitalize', letterSpacing: '0.2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <i className="fa-solid fa-link" style={{ color: '#64748b', fontSize: '0.9rem' }}></i> URL Path <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g. /dashboard"
                                    name="urlPath"
                                    value={formData.urlPath}
                                    onChange={handleInputChange}
                                    required
                                    style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', boxShadow: 'none', transition: 'all 0.2s', fontSize: '0.85rem', backgroundColor: '#ffffff' }}
                                    onFocus={(e) => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 4px rgba(59, 130, 246, 0.1)'; }}
                                    onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="gx-4">
                        <Col md={6}>
                            <Form.Group className="mb-4">
                                <Form.Label style={{ color: '#64748b', fontWeight: '600', fontSize: '0.85rem', marginBottom: '8px', textTransform: 'capitalize', letterSpacing: '0.2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <i className="fa-solid fa-key" style={{ color: '#64748b', fontSize: '0.9rem' }}></i> Menu Key <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g. DASHBOARD_MENU"
                                    name="menuKey"
                                    value={formData.menuKey}
                                    onChange={(e) => {
                                        const value = e.target.value.toUpperCase().replace(/[^A-Z_]/g, '');
                                        handleInputChange({ target: { name: 'menuKey', value: value } });
                                    }}
                                    required
                                    style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', boxShadow: 'none', transition: 'all 0.2s', fontSize: '0.85rem', backgroundColor: '#ffffff' }}
                                    onFocus={(e) => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 4px rgba(59, 130, 246, 0.1)'; }}
                                    onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-4">
                                <Form.Label style={{ color: '#64748b', fontWeight: '600', fontSize: '0.85rem', marginBottom: '8px', textTransform: 'capitalize', letterSpacing: '0.2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    Position (Order) <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="e.g. 1"
                                    name="menuPosition"
                                    value={formData.menuPosition}
                                    onChange={handleInputChange}
                                    required
                                    style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', boxShadow: 'none', transition: 'all 0.2s', fontSize: '0.85rem', backgroundColor: '#ffffff' }}
                                    onFocus={(e) => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 4px rgba(59, 130, 246, 0.1)'; }}
                                    onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="gx-4">
                        <Col md={6}>
                            <Form.Group className="mb-4">
                                <Form.Label style={{ color: '#64748b', fontWeight: '600', fontSize: '0.85rem', marginBottom: '8px', textTransform: 'capitalize', letterSpacing: '0.2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    Menu Icon <span className="text-danger">*</span>
                                </Form.Label>
                                <Select
                                    options={iconOptions}
                                    value={iconOptions.find(opt => opt.value === formData.menuIcon) || null}
                                    onChange={handleIconChange}
                                    formatOptionLabel={formatOptionLabel}
                                    placeholder="Search and select an icon..."
                                    isClearable
                                    required
                                    menuPosition="fixed"
                                    menuPlacement="auto"
                                    styles={reactSelectStyles}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-4">
                                <Form.Label style={{ color: '#64748b', fontWeight: '600', fontSize: '0.85rem', marginBottom: '8px', textTransform: 'capitalize', letterSpacing: '0.2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    Menu Type <span className="text-danger">*</span>
                                </Form.Label>
                                <Select
                                    options={[
                                        { value: 'Parent Menu', label: 'Parent Menu' },
                                        { value: 'Sub Menu', label: 'Sub Menu' }
                                    ]}
                                    value={{ value: formData.menuType, label: formData.menuType }}
                                    onChange={(selectedOption) => handleInputChange({ target: { name: 'menuType', value: selectedOption ? selectedOption.value : '' } })}
                                    isClearable={false}
                                    required
                                    menuPosition="fixed"
                                    menuPlacement="auto"
                                    styles={reactSelectStyles}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {formData.menuType === 'Sub Menu' && (
                        <Row className="gx-4">
                            <Col md={6}>
                                <Form.Group className="mb-4">
                                    <Form.Label style={{ color: '#64748b', fontWeight: '600', fontSize: '0.85rem', marginBottom: '8px', textTransform: 'capitalize', letterSpacing: '0.2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        Parent Menu <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Select
                                        options={uniqueParentMenus.map(name => ({ value: name, label: name }))}
                                        value={formData.parentMenu ? { value: formData.parentMenu, label: formData.parentMenu } : null}
                                        onChange={(selectedOption) => handleInputChange({ target: { name: 'parentMenu', value: selectedOption ? selectedOption.value : '' } })}
                                        placeholder="Select Parent Menu"
                                        isClearable
                                        required={formData.menuType === 'Sub Menu'}
                                        menuPosition="fixed"
                                        menuPlacement="auto"
                                        styles={reactSelectStyles}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    )}

                    <div style={{ marginTop: '10px' }}>
                        <Form.Group>
                            <Form.Label style={{ color: '#1e293b', fontWeight: '700', fontSize: '1rem', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <i className="fa-solid fa-shield-halved" style={{ color: '#1e293b' }}></i>
                                Allowed Actions (Permissions) <span className="text-danger">*</span>
                            </Form.Label>

                            <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', width: '100%', alignItems: 'center' }}>
                                <Form.Control 
                                    type="text" 
                                    placeholder="Add custom action (e.g. Upload)" 
                                    value={newActionInput}
                                    onChange={(e) => setNewActionInput(e.target.value)}
                                    style={{ padding: '10px 14px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '0.9rem', width: '320px' }}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            const trimmed = newActionInput.trim();
                                            if (trimmed && !availableActions.some(a => a.toLowerCase() === trimmed.toLowerCase())) {
                                                setAvailableActions([...availableActions, trimmed]);
                                                setNewActionInput('');
                                            }
                                        }
                                    }}
                                />
                                <button 
                                    type="button" 
                                    onClick={() => {
                                        const trimmed = newActionInput.trim();
                                        if (trimmed && !availableActions.some(a => a.toLowerCase() === trimmed.toLowerCase())) {
                                            setAvailableActions([...availableActions, trimmed]);
                                            setNewActionInput('');
                                        }
                                    }}
                                    style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', backgroundColor: newActionInput.trim() ? '#10b981' : '#94a3b8', color: '#fff', fontSize: '0.9rem', fontWeight: '600', cursor: newActionInput.trim() ? 'pointer' : 'not-allowed', transition: 'background-color 0.2s' }}
                                    disabled={!newActionInput.trim()}
                                    onMouseOver={(e) => { if(newActionInput.trim()) e.target.style.backgroundColor = '#059669' }}
                                    onMouseOut={(e) => { if(newActionInput.trim()) e.target.style.backgroundColor = '#10b981' }}
                                >
                                    Add Action
                                </button>
                            </div>

                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', width: '100%' }}>
                                {availableActions.map((action, index) => {
                                    const isChecked = formData.allowedActions?.includes(action) || false;
                                    return (
                                        <div 
                                            key={index}
                                            style={{
                                                width: 'fit-content',
                                                padding: '12px 16px',
                                                borderRadius: '8px',
                                                border: '1px solid #e2e8f0',
                                                backgroundColor: '#f8fafc',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '12px',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                userSelect: 'none'
                                            }}
                                            onClick={() => {
                                                const actions = formData.allowedActions || [];
                                                const newActions = isChecked
                                                    ? actions.filter(a => a !== action)
                                                    : [...actions, action];
                                                setFormData({ ...formData, allowedActions: newActions });
                                            }}
                                            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f1f5f9'; }}
                                            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#f8fafc'; }}
                                        >
                                            <div style={{
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '4px',
                                                backgroundColor: isChecked ? '#0ea5e9' : '#fff',
                                                border: isChecked ? 'none' : '1px solid #cbd5e1',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                transition: 'all 0.2s'
                                            }}>
                                                {isChecked && <i className="fa-solid fa-check" style={{ color: '#fff', fontSize: '12px' }}></i>}
                                            </div>
                                            <span style={{ 
                                                color: '#1e293b', 
                                                fontWeight: '600',
                                                fontSize: '0.95rem'
                                            }}>
                                                {action}
                                            </span>
                                            {action.toLowerCase() !== 'view' && (
                                                <i 
                                                    className="fa-solid fa-times"
                                                    style={{
                                                        marginLeft: '4px',
                                                        color: '#94a3b8',
                                                        fontSize: '14px',
                                                        padding: '4px',
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        transition: 'all 0.2s ease',
                                                        width: '24px',
                                                        height: '24px'
                                                    }}
                                                    onMouseOver={(e) => { e.currentTarget.style.color = '#ef4444'; e.currentTarget.style.backgroundColor = '#fee2e2'; }}
                                                    onMouseOut={(e) => { e.currentTarget.style.color = '#94a3b8'; e.currentTarget.style.backgroundColor = 'transparent'; }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setAvailableActions(availableActions.filter(a => a !== action));
                                                        setFormData({
                                                            ...formData,
                                                            allowedActions: (formData.allowedActions || []).filter(a => a !== action)
                                                        });
                                                    }}
                                                ></i>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </Form.Group>
                    </div>

                    </div>
                    <div style={{ padding: '24px 32px', borderTop: '1px solid #f1f5f9', backgroundColor: '#ffffff', display: 'flex', justifyContent: 'flex-end', gap: '16px', flexShrink: 0 }}>
                        <div style={{ display: 'flex', gap: '12px', width: 'auto' }}>
                            <button type="button" onClick={onHide} style={{ border: '1px solid #e2e8f0', backgroundColor: '#ffffff', color: '#475569', padding: '10px 24px', borderRadius: '10px', fontWeight: '600', fontSize: '0.95rem', transition: 'all 0.2s', boxShadow: '0 1px 2px rgba(0,0,0,0.05)', minWidth: '120px' }} onMouseOver={(e) => { e.target.style.backgroundColor = '#f8fafc'; e.target.style.color = '#1e293b'; }} onMouseOut={(e) => { e.target.style.backgroundColor = '#ffffff'; e.target.style.color = '#475569'; }}>
                                Cancel
                            </button>
                            <button type="submit" style={{ backgroundColor: '#3b82f6', borderColor: '#3b82f6', color: '#fff', padding: '10px 24px', borderRadius: '10px', fontWeight: '600', fontSize: '0.95rem', transition: 'all 0.2s', boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.3), 0 2px 4px -1px rgba(59, 130, 246, 0.2)', minWidth: '140px' }} onMouseOver={(e) => { e.target.style.backgroundColor = '#2563eb'; e.target.style.boxShadow = '0 10px 15px -3px rgba(59, 130, 246, 0.4), 0 4px 6px -2px rgba(59, 130, 246, 0.2)'; e.target.style.transform = 'translateY(-1px)'; }} onMouseOut={(e) => { e.target.style.backgroundColor = '#3b82f6'; e.target.style.boxShadow = '0 4px 6px -1px rgba(59, 130, 246, 0.3), 0 2px 4px -1px rgba(59, 130, 246, 0.2)'; e.target.style.transform = 'none'; }}>
                                Update Menu
                            </button>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default EditAppMenu;
